import { render, staticRenderFns } from "./BookmarkManage.vue?vue&type=template&id=75d7cb44&scoped=true"
import script from "./BookmarkManage.vue?vue&type=script&lang=js"
export * from "./BookmarkManage.vue?vue&type=script&lang=js"
import style0 from "./BookmarkManage.vue?vue&type=style&index=0&id=75d7cb44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d7cb44",
  null
  
)

export default component.exports